export default __webpack_public_path__ + "static/media/TooltipIsolated.a9ca151f.svg";